import ConfirmModal from '../ConfirmModal'

type Props = {
    open: boolean
    onClose: () => void
    onConfirm: () => Promise<void>
    loading: boolean
}

function DeleteCookieModal({ open, onClose, onConfirm, loading }: Props) {
    return (
        <ConfirmModal
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Delete cookie"
            description="Are you sure you want to delete this cookie? This action cannot be undone."
            confirmLabel="Delete"
            loading={loading}
        />
    )
}

export default DeleteCookieModal
